import React from 'react';

const GlobalSettings = ()=>{
    return (<React.Fragment>
        <h1>List of GlobalSettings</h1>
    </React.Fragment>)
};

export default GlobalSettings;